import styled from 'styled-components'

import { breakpoints } from 'style'

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 60px 120px;

  .overview-items {
    display: flex;
    flex-direction: column;

    .overview-item {
      display: flex;

      margin-bottom: 60px;

      .icon {
        font-size: 100px;
        margin-right: 80px;
      }

      p {
        margin-top: 15px;
      }
    }
  }

  .next-page {
    width: 41.66%;
    margin-left: auto;
  }

  @media (max-width: ${breakpoints.md}px) {
    margin: 30px 60px;

    .overview-items {
      .overview-item {
        display: block;
        margin-bottom: 30px;

        .icon {
          margin-right: 40px;
          margin-bottom: 10px;
          float: left;
        }

        p {
          margin-top: 5px;
        }
      }
    }

    .next-page {
      width: 83.33%;
      margin: auto;
    }
  }
`
